module.exports = __webpack_public_path__ + "static/markdown-table-generator-0b04636d471e5141949a3b7a1cde9b20.png";